export default ({ attributes }) => {
  const {
    margin,
    image,
    imagePosition,
    hideDesktop,
    hideMobile,
    absolute,
    positionAbsolute,
    positionAbsoluteVertical,
    borderRadius,
  } = attributes;

  return (
    <div
      className={`Image ${margin} ${imagePosition} ${
        hideDesktop ? 'desktop' : ''
      } ${hideMobile ? 'mobile' : ''}  ${absolute ? positionAbsolute : ''} ${
        absolute ? positionAbsoluteVertical : ''
      }`}
    >
      <figure className="Image__content">
        <img
          src={image.src}
          title={image.alt}
          width={image.width}
          height={image.height}
          alt={image.alt}
          style={{ borderRadius: `${borderRadius}px` }}
        />
      </figure>
    </div>
  );
};
